import Formats from '../components/HomePage/Formats/Formats';
import Company from '../components/HomePage/Company/Company';
import CompetencyStrip from '../components/HomePage/CompetencyStrip/CompetencyStrip';
import FAQSection from '../components/HomePage/FAQSection/FAQSection';
import Header from '../components/HomePage/Header/Header';
import { HomeSectionsAccordionProvider } from '../components/HomePage/HomeSectionAccordion/HomeSectionAccordion';
import Partners from '../components/HomePage/Partners/Partners';
import ProjectsPreview from '../components/HomePage/ProjectsPreview/ProjectsPreview';
import HomeQuoteCTA from '../components/HomePage/HomeQuoteCTA/HomeQuoteCTA';
import ScrollToggle from '../components/HomePage/ScrollToggle/ScrollToggle';
import Services from '../components/HomePage/Services/Services';
import Trust from '../components/HomePage/Trust/Trust';
import Workflow from '../components/HomePage/Workflow/Workflow';
import './Home.css';

const Home = () => {
  return (
    <>
      <Header />

      <main className="home-page">
        <CompetencyStrip />
        <HomeSectionsAccordionProvider>
          <Services />
          <ProjectsPreview />
          <Partners />
          <Trust />
          <Company />
          <Workflow />
          <Formats />
          <FAQSection />
        </HomeSectionsAccordionProvider>
        <HomeQuoteCTA />
      </main>

      <ScrollToggle target="home-cta" />
    </>
  );
};

export default Home;
